import React from 'react';
import { useNavigate } from 'react-router-dom';

const ProfileTabs = ({ activeTab, setActiveTab }) => {
  const navigate = useNavigate();

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    navigate(`/minha-conta?tab=${tab}`);
  };

  const tabs = [
    { id: 'informacoes', label: 'Informações' },
    { id: 'enderecos', label: 'Endereços' },
    { id: 'seguranca', label: 'Segurança' },
    { id: 'entrega', label: 'Entrega' },
    { id: 'meus-pedidos', label: 'Pedidos' }
  ];

  return (
    <div className='flex justify-start w-full overflow-x-auto pb-2'>
      <div className="grid w-full grid-cols-3 md:grid-cols-5 gap-1 bg-gray-100 p-1 rounded-lg min-w-[300px]">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => handleTabChange(tab.id)}
            className={`px-2 py-2 text-xs sm:text-sm font-medium rounded-md transition-colors whitespace-nowrap ${
              activeTab === tab.id
                ? 'bg-white text-green-600 shadow-sm'
                : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProfileTabs;